<template>
    <div class="loading" spinner=""   style="position: relative;">
        <svg viewBox="0 0 80 24" class="shadow"  style="transform: rotate(2.26393deg) scale(1.15);">
            <path d="M6.064188334437068 7.678147022344706L60.24850694311091 1.9412779656435646L58.34099801726341 15.183174772987343L14.038455411954859 20.060416446826128L6.064188334437068 7.678147022344706Z" style="fill: #0062F9;"></path>
            </svg>
        <svg viewBox="0 0 80 24"  style="transform: rotate(2.26393deg) scale(1.15);">
                <path d="M6.064188334437068 7.678147022344706L60.24850694311091 1.9412779656435646L58.34099801726341 15.183174772987343L14.038455411954859 20.060416446826128L6.064188334437068 7.678147022344706Z" style="fill: #FF04B4;"></path></svg>
                <p class="small upper" >Loading</p>
    </div>
</template>

<script>
export default {
  name: 'PunkLoading',
  props: {
    text: String
  }
}
</script>

<style scoped>
@-webkit-keyframes spin {
    from {
        transform: rotate(0)
    }

    to {
        transform: rotate(360deg)
    }
}

@keyframes spin {
    from {
        transform: rotate(0)
    }

    to {
        transform: rotate(360deg)
    }
}

.loading {
    width: 5rem;
    height: 1.5rem;
    margin: 5rem auto;
}

.loading svg {
    overflow: visible;
    margin: 0;
    top: 0
}

.loading svg path {
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    transform-origin: center
}

.loading svg:last-of-type path {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
    animation-direction: reverse
}

.loading p {
    margin: 1rem 0 0;
    -webkit-animation: spin 3s linear infinite;
    animation: spin 3s linear infinite;
   color: #FFFFFF!important;
    font-family: 'Space Mono',monospace,-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
}
svg  {
    position: absolute;
    top: -10%;
    left: -10%;
    width: 120%;
    height: 120%;
    z-index: -1;

}

</style>
